import { version } from '../../package.json';
import { formatConfig, getFilePaths } from '../utilities';
import { loadVA } from './loadVA';

const xhr = new XMLHttpRequest();

xhr.onload = () => {
  if (xhr.status >= 200 && xhr.status < 300) {
    let config = {};

    if (xhr.response) {
      const receivedConfig = JSON.parse(xhr.response);
      config = formatConfig(receivedConfig, window.__va__.source);
    }

    const filePaths = getFilePaths(config.files);
    /**
     * version uses to troubleshoot caching issue
     */
    const changedFilePaths = filePaths.map(file => {
      file += `?ver=${version}`;
      return file;
    });

    if (config.enabled || config.enabled === undefined) {
      loadVA(config, changedFilePaths);
    }
  } else {
    console.error(xhr.responseText);
  }
};

/**
 * Loads the configuration by the specified va id.
 * Then loads and initializes the application.
 */
xhr.open('GET', window.__va__.path);
xhr.send();
